export enum StatusStates {
    WAITING = 'waiting',
    WIN = 'win',
    LOSE = 'lose',
    LOADING = 'loading',
    FAILED = 'failed'
}
